export interface IGeneric {
    [key: string]: any;
}